<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="搜索内容：" label-for="key">
              <Input search enter-button placeholder="请输入商品名称搜索" clearable v-model="filter.search" @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选店铺：" label-for="key">
              <Select v-model="filter.shop_id" @on-change="select">
                <Option value="0" >全部</Option>
                <Option v-for="(item,key) in shopList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选分类：" label-for="key">
              <Select v-model="filter.cate_id" @on-change="select">
                <Option value="0" >全部</Option>
                <Option v-for="(item,key) in goodsCategoryList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="商品状态：" label-for="key">
              <Select v-model="filter.status" @on-change="select">
                <Option :value="-1" >全部</Option>
                <Option :value="0" >下架</Option>
                <Option :value="1" >上架</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="审核状态：" label-for="key">
              <Select v-model="filter.is_verify" @on-change="select">
                <Option :value="-1" >全部</Option>
                <Option :value="0" >待审核</Option>
                <Option :value="1" >已审核</Option>
                <Option :value="2" >审核拒绝</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="推荐状态：" label-for="key">
              <Select v-model="filter.is_recommend" @on-change="select">
                <Option :value="-1" >全部</Option>
                <Option :value="0" >不推荐</Option>
                <Option :value="1" >推荐</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="精品状态：" label-for="key">
              <Select v-model="filter.is_premium" @on-change="select">
                <Option :value="-1" >全部</Option>
                <Option :value="0" >否</Option>
                <Option :value="1" >是</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="溯源推荐：" label-for="key">
              <Select v-model="filter.traceability_recommendation" @on-change="select">
                <Option :value="-1" >全部</Option>
                <Option :value="0" >不推荐</Option>
                <Option :value="1" >推荐</Option>
              </Select>
            </FormItem>
          </Col>

        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">
          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

<!--        上架状态-->
        <template slot-scope="{ row, index }" slot="status">
          <i-switch size="large" v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeStatus(row)">
            <span slot="open">上架</span>
            <span slot="close">下架</span>
          </i-switch>
        </template>

<!--        溯源推荐-->
        <template slot-scope="{ row, index }" slot="traceability_recommendation">
          <i-switch v-if="row.is_franchised_goods" v-model="row.traceability_recommendation" :value="row.traceability_recommendation" :true-value="1" :false-value="0"
                    @on-change="changeGoodsTraceabilityRecommendation(row)">
          </i-switch>
        </template>

<!--        审核状态-->
        <template slot-scope="{ row, index }" slot="is_verify">
          <span style="color: orange" v-if="row.is_verify == 0">待审核</span>
          <span style="color: green" v-if="row.is_verify == 1">已通过</span>
          <span style="color: red" v-if="row.is_verify == 2">未通过</span>
        </template>

<!--        商品封面图-->
        <template slot-scope="{ row, index }" slot="cover">
          <div class="tabBox_img">
            <a @click="showImage(row.cover)">
              <img :src="row.cover" alt="">
            </a>
          </div>
        </template>

<!--        商品轮播图-->
        <template slot-scope="{ row, index }" slot="pics">
          <!--            循环渲染-->
          <div class="tabBox_img" style="display: inline-block;margin-right: 4px;" v-for="(item, index) in row.pics" :key="index" >
            <a @click="showImage(item)">
              <img :src="item" alt="">
            </a>
          </div>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.goods_id)">编辑</a>
          <Divider type="vertical" />
          <a @click="info(row.goods_id)">查看</a>
          <Divider type="vertical"/>
          <a @click="shen(row)" :disabled="row.is_verify !== 0">审核</a>
          <Divider type="vertical"/>
          <a @click="del(row.goods_id)">删除</a>
          <Divider type="vertical"/>
          <a @click="recommand(row)">推荐</a>
          <Divider type="vertical"/>
          <a @click="traceability(row)" :disabled="!row.is_franchised_goods" >二维码</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>

    <Modal
      v-model="qrCodeShow"
      title="商品二维码">
      <div style="width: 100%;height: 100%;display: flex;justify-content: center;">
        <img :src="qrCodeUrl" alt="商品二维码">
      </div>
      <div slot="footer">
        <Button type="primary" @click="qrCodeOk">下载</Button>
        <Button @click="qrCodeCancel">关闭</Button>
      </div>
    </Modal>

    <goodsEdit :editShow="isShowGoodsEdit" :id="goods_id" @updateStatusModel="updateStatusModel"></goodsEdit>
    <commend-edit :editShow="isCommendEdit" :id="goods_id" @updateStatusModel="updateStatusModel"></commend-edit>
  </div>
</template>
<script>
import {goodsListApi, changeGoodsStatusApi, changeGoodsTraceabilityRecommendation, generateGoodsQrcodeApi, goodsDelApi} from '@/api/goods/goods'
import modalSure from '@/components/modalSure'
import goodsEdit from '../components/goodsEdit'
import commendEdit from '@/view/goods/components/commendEdit'
import {shopAllApi} from "@/api/shop/shop";
import {goodsCategoryAllApi} from "@/api/goods/goodsCategory";
import {showImageModal} from "_c/common/showImageModal";

export default {
  name: 'goodsList',
  components: { modalSure, goodsEdit, commendEdit },
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      ShopExportTableShow: false,
      filter: {
        page: 1,
        limit: 10,
        search: '',
        shop_id: '0',
        cate_id: '0',
        status: -1,
        is_verify: -1,
        is_recommend: -1,
        is_premium: -1,
        traceability_recommendation: -1,
      },
      shopList: [],
      goodsCategoryList: [],
      qrCodeShow: false,
      qrCodeId: 0,
      qrCodeUrl: '',
      goods_id: 0,
      tableCount: 0,
      tableData: [],
      loading: false,
      isShowGoodsEdit: false,
      isCommendEdit: false,
      userid: 0,
      columns: [
        {
          title: '商品封面图',
          slot: 'cover',
          minWidth: 120
        },
        {
          title: '商品名称',
          key: 'goods_title',
          minWidth: 300
        },
        {
          title: '店铺名称',
          key: 'shop_name',
          minWidth: 200
        },
        {
          title: '商品分类',
          key: 'cate_name',
          minWidth: 150
        },
        {
          title: '商品轮播图',
          slot: 'pics',
          minWidth: 300
        },
        {
          title: '商品原价',
          key: 'origin_price',
          minWidth: 120
        },
        {
          title: '商品销售价',
          key: 'sale_price',
          minWidth: 120
        },
        {
          title: '销量',
          key: 'sales',
          minWidth: 120
        },
        {
          title: '库存',
          key: 'stock',
          minWidth: 120
        },
        {
          title: '单位',
          key: 'unit',
          minWidth: 120
        },
        {
          title: '商品地域',
          key: 'area',
          minWidth: 120
        },
        {
          title: '溯源推荐',
          slot: 'traceability_recommendation',
          minWidth: 120
        },
        {
          title: '溯源视频',
          minWidth: 120,
          ellipsis: true,
          render: (h, params) => {
            return h('div', [
              h('span', params.row.video_url ? '有' : '暂无')
            ])
          }
        },
        {
          title: '商品状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '审核状态',
          slot: 'is_verify',
          minWidth: 120
        },
        {
          title: '驳回原因',
          key: 'refuse_reason',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 320
        }
      ]
    }
  },
  created () {
    this.loadShopData()
    this.loadGoodsCategoryData()
    this.loadTableData()
  },
  activated () {
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.ids = []
      this.loading = true
      goodsListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },

    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },

    // 搜索
    search() {
      this.filter.page = 1
      this.loadTableData()
    },

    // 搜索清空
    searchClear() {
      this.filter.page = 1
      this.filter.search = ''
      this.loadTableData()
    },

    // 下拉选择
    select () {
      this.filter.page = 1
      this.loadTableData()
    },

    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 编辑
    edit (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'edit', id) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },

    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除？',
        onOk: () => {
          goodsDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    shen (val) {
      this.goods_id = val.goods_id
      this.isShowGoodsEdit = true
    },
    recommand (val) {
      this.goods_id = val.goods_id
      this.isCommendEdit = true
    },

    // 修改商品状态
    changeStatus (row) {
      changeGoodsStatusApi(row.goods_id).then(async res => {
        this.$Message.success(res.msg)
        this.loadTableData()
      }).catch(res => {
        this.$Message.error(res.msg)
        this.loadTableData()
      })
    },

    // 修改黄河商品溯源推荐状态
    changeGoodsTraceabilityRecommendation (row) {
      changeGoodsTraceabilityRecommendation(row.goods_id).then(async res => {
        this.$Message.success(res.msg)
        this.loadTableData()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 黄河商品二维码
    traceability (row) {

      this.qrCodeId = row.goods_id
      generateGoodsQrcodeApi(row.goods_id).then(response => {
        const blob = response.data;
        this.qrCodeUrl = ''
        if (blob && blob instanceof Blob) {
          this.qrCodeUrl = window.URL.createObjectURL(blob);
          this.qrCodeShow = true;
        } else {
          console.error('响应数据不是有效的 Blob 对象:', blob);
        }
      }).catch(error => {
        console.error('下载二维码失败', error);
        if (error.response) {
          console.error('响应错误:', error.response.data);
          console.error('响应状态码:', error.response.status);
          console.error('响应头:', error.response.headers);
        } else if (error.request) {
          console.error('请求错误:', error.request);
        } else {
          console.error('其他错误:', error.message);
        }
      });

    },

    // 二维码展示 返回
    qrCodeCancel(){
      this.qrCodeShow = false
      setTimeout(() => {
        this.qrCodeUrl = ''
        this.qrCodeId = 0
        window.URL.revokeObjectURL(this.qrCodeUrl);
      }, 500);
    },

    // 二维码展示 下载
    qrCodeOk(){
      // 创建一个下载链接并触发下载
      const link = document.createElement('a');
      link.href = this.qrCodeUrl;
      link.download = `商品二维码${this.qrCodeId}.png`; // 文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.qrCodeShow = false
      setTimeout(() => {
        this.qrCodeUrl = ''
        this.qrCodeId = 0
        window.URL.revokeObjectURL(this.qrCodeUrl);
      }, 500);
    },

    // 加载店铺
    async loadShopData () {
      shopAllApi({type: 2}).then(res => {
        if (res.code === 200) {
          this.shopList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    // 加载商品分类
    loadGoodsCategoryData() {
      goodsCategoryAllApi().then(res => {
        this.goodsCategoryList = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },

    updateStatusModel () {
      this.isShowGoodsEdit = false
      this.reload()
    },

    // 图片放大
    showImage(url){
      showImageModal(url)
    }

  }

}
</script>
